<template>
    <Section width="md">
        <h1>
            {{ 
                $translate('redirect_message_h1', 'Häng kvar, du skickas vidare till {title}!')
                    .replace('{title}', document.data.title) 
            }}
        </h1>

        <PrismicImage
            :img="image"
            w="400"
            h="auto"
            :lazy="false"
        />
    </Section>
</template>

<script>
import getDocument from '@/plugins/get-document.js';
export default {
    async middleware({ store, $prismic, route }) {
        await store.dispatch('fetchStates', {$prismic, route});
    },
    async asyncData({$prismic, route, error}) {
        try {
            return await getDocument($prismic, route.path, error, 'out');
        }
        catch (e) {
            error({statusCode: 404, message: 'Not found'});
        }
    },
    head() {
        return {
            title: 'Redirecting',
            meta: [
                { name: 'robots', content: 'noindex' }
            ]
        };
    },
    computed: {
        image() {
            return {
                dimensions: {
                    width: 1920,
                    height: 960
                },
                alt: 'redirecting',
                copyright: null,
                url: 'https://images.prismic.io/lanen/e91f8c7e-7c15-4d3b-9259-10aec7872059_la%CC%8Anen-redirect.webp?auto=compress,format'
            };
        }
    },
    mounted() {
        window.location.assign(
            this.$tracking.addTrackingParameters(this.document.data.redirect, this.$route.query)
        );
    }
};
</script>

<style lang="scss" scoped>
    section::v-deep {
        background: $green;
        height: 100vh;

        .section-inner {
            @include flex;
            color: $white;

            h1 {
                @include spacing(margin,6,bottom);
                text-align: center;
            }

            img {
                max-width: 100%;
            }
        }
    }
</style>
